<div class="welcome-container">
  <div class="welcome-content">
    <!-- Logo/Header Section -->
    <div class="header-section">
      <div class="logo-container">
        <img src="./assets/images/logoImg.png" alt="Logo" class="app-logo" />
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-section">
      <div class="badge-container">
        <span class="badge-new">{{ 'users.welcome.newExperience' | translate }}</span>
      </div>

      <h1 class="welcome-title">
        {{ 'users.welcome.titleLine1' | translate }}<br/>
        <span class="highlight">{{ 'users.welcome.titleHighlight' | translate }}</span><br/>
        {{ 'users.welcome.titleLine3' | translate }}
      </h1>

      <p class="welcome-subtitle">
        {{ 'users.welcome.subtitle' | translate }}
      </p>

      <div class="features-grid">
        <div class="feature-item">
          <div class="feature-icon">
            <i class="pi pi-bolt"></i>
          </div>
          <div class="feature-text">
            <h3>{{ 'users.welcome.feature1Title' | translate }}</h3>
            <p>{{ 'users.welcome.feature1Desc' | translate }}</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <i class="pi pi-mobile"></i>
          </div>
          <div class="feature-text">
            <h3>{{ 'users.welcome.feature2Title' | translate }}</h3>
            <p>{{ 'users.welcome.feature2Desc' | translate }}</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <i class="pi pi-shield"></i>
          </div>
          <div class="feature-text">
            <h3>{{ 'users.welcome.feature3Title' | translate }}</h3>
            <p>{{ 'users.welcome.feature3Desc' | translate }}</p>
          </div>
        </div>

        <div class="feature-item">
          <div class="feature-icon">
            <i class="pi pi-sparkles"></i>
          </div>
          <div class="feature-text">
            <h3>{{ 'users.welcome.feature4Title' | translate }}</h3>
            <p>{{ 'users.welcome.feature4Desc' | translate }}</p>
          </div>
        </div>
      </div>

      <!-- CTA Buttons -->
      <div class="cta-section">
        <button class="btn-primary-cta" (click)="navigateToNewUI()">
          <span>{{ 'users.welcome.accessNewPlatform' | translate }}</span>
          <i class="pi pi-arrow-right"></i>
        </button>

        <div class="legacy-link">
          <a (click)="navigateToOldUI(); $event.preventDefault()" href="#">
            <i class="pi pi-history"></i>
            {{ 'users.welcome.returnToPrevious' | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <p class="footer-text">
        {{ 'users.welcome.footer' | translate }}
      </p>
    </div>
  </div>

  <!-- Background Decoration -->
  <div class="bg-decoration">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
    <div class="circle circle-3"></div>
  </div>
</div>
